import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const LineItemsBulkAccrualCoaCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedLineItemCount = 0,
        hasSelectedAllMatchingLineItems = false,
        lineItemsBulkAccrualCoaOptions = [],
    } = options;

    const selectionDescription = hasSelectedAllMatchingLineItems
        ? "all matching line items"
        : pluralizeWithCount("line item", selectedLineItemCount);

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set accrual ledger for ${selectionDescription}`}
            options={lineItemsBulkAccrualCoaOptions}
        />
    );
};
